__webpack_require__.p = "/static/site_platform/react-menu/";